import ApiConstants from "../../Constants/ApiConstant";
import { apiGet, apiPost, apiPut } from "../../Services/ApiService";

export const getSubscriptionAPI = (params, callBack) => {
  return async () => {
    try {
      const response = await apiGet(`${ApiConstants.subscriptionUrl}`, {
        params,
      });
      callBack && callBack(response, response?.data);
    } catch (error) {
      console.log("get subscription api err:", error);
      throw error;
    }
  };
};

// export const getActiveSubscriptionAPI = (params, callBack) => {
//   return async () => {
//     try {
//       const response = await apiGet(`${ApiConstants.activateSubscriptionUrl}`, {
//         params,
//       });
//       callBack && callBack(response, response?.data);
//     } catch (error) {
//       console.log("get active subscription api err:", error);
//       throw error;
//     }
//   };
// };

export const getActiveSubscriptionAPI = (data, callBack) => {
  return async () => {
    try {
      await apiGet(ApiConstants.getActiveSubscriptionUrl, data)
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
        
          throw err;
        });
    } catch (err) {
   
      throw err;
    }
  };
};

export const AddSubscriptionAPI = (data, callBack) => {
  return async () => {
    try {
      await apiPost(ApiConstants.AddSubscriptionUrl, data)
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("add subscription api err===-=>>>:", err);
          throw err;
        });
    } catch (err) {
      console.log("add subscription api err:", err);
      throw err;
    }
  };
};

export const updateSubscriptionAPI = (data, callBack) => {
  return async () => {
    try {
      await apiPut(ApiConstants.updateSubscriptionUrl, data)
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("update subscription api err===-=>>>:", err);
          throw err;
        });
    } catch (err) {
      console.log("update subscription api err:", err);
      throw err;
    }
  };
};
